import { useQuery, useSuspenseQuery } from "@tanstack/react-query";

import { api } from "./ApiClient";

import { AuthHelper } from "../helpers/auth.helper";

import { IEntitlementsData } from "../types/misc.interface";

const EFFECTIVE_ENTITLEMENTS_QUERY_KEY = ['effective-entitlements-for-user'] as const;

const fetchEffectiveEntitlementsForUser = async (): Promise<IEntitlementsData> => {
    const res = await api.get(`/entitlements/effective-for-user`);
    return res.data;
};

export const useGetEffectiveEntitlementsForUser = () => {
    AuthHelper.presetPrivateRequest(api);

    const isAuthTokenValid = AuthHelper.isAuthTokenValid().result;
    const isGuestTokenValid = AuthHelper.isGuestTokenValid().result;

    return useQuery({
        queryKey: EFFECTIVE_ENTITLEMENTS_QUERY_KEY,
        queryFn: fetchEffectiveEntitlementsForUser,
        enabled: isAuthTokenValid || isGuestTokenValid,
    });
};

export const useSuspenseEffectiveEntitlementsForUser = () => {
    AuthHelper.presetPrivateRequest(api);

    return useSuspenseQuery({
        queryKey: EFFECTIVE_ENTITLEMENTS_QUERY_KEY,
        queryFn: fetchEffectiveEntitlementsForUser,
    });
};